import {
	type Session,
	type SaveSessionRequest,
	apiAppBusinessSessionDelete,
	apiAppBusinessSessionList,
	apiAppBusinessSessionUpsert
} from '#lib/types/generated/index.js';
import { toSaveSessionEngineRequest } from '#lib/helper/session.js';
import { optimisticArchive, optimisticSave } from '#lib/stores/optimistic.js';
import { writable } from 'svelte/store';

export const sessionStore = writable<Session[]>([]);

export function reloadSessions(): Promise<Session[]> {
	return apiAppBusinessSessionList().then((res) => {
		sessionStore.set(res.items);
		return res.items;
	});
}

export function saveSession(session: Session): Promise<Session> {
	const payload: SaveSessionRequest = {
		parentId: session.parentId,
		name: session.name,
		color: session.color,
		maxBooking: session.maxBooking,
		followAllAreas: session.followAllAreas,
		areas: session.areas,
		engine: toSaveSessionEngineRequest(session.engine),
		conferenceProvider: session.conferenceProvider ?? null,
		googleConferenceAuthId:
			session.googleConferenceAuthId != null ? String(session.googleConferenceAuthId) : null,
		conferenceUrl: session.conferenceUrl ?? null
	};
	return optimisticSave(sessionStore, session, () =>
		apiAppBusinessSessionUpsert(session.id, payload)
	);
}

export function deleteSession(session: Session): Promise<void> {
	return optimisticArchive(sessionStore, session, () =>
		apiAppBusinessSessionDelete(session.id).then(() => {})
	);
}
